module.exports = "<select \r\n\tclass=\"w3-select w3-block w3-border w3-round\"\r\n\t[(ngModel)]=\"value\"\r\n\t[disabled]=\"isDisabled\">\r\n\t<option [value]=\"null\">Select user</option>\r\n\t<option *ngFor=\"let u of users\" [value]=\"u.key\">{{u.value}}</option>\r\n</select>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-user-select/ztsi-user-select.component.html
// module id = ./src/app/components/shared/ztsi-user-select/ztsi-user-select.component.html
// module chunks = main